import { Service } from 'typedi';

@Service()
export class LocalStorageService {
  readonly localStorage: Storage;

  constructor() {
    this.localStorage = localStorage;
  }
}
